// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rknu6s59issafFobTt9o{flex-direction:column;flex-grow:1;width:620px;max-width:calc(100% - 88px);margin:0 auto;padding:0 20px;display:flex;overflow-x:hidden;overflow-y:auto}@media (min-width:992px){.Rknu6s59issafFobTt9o{width:760px;max-width:none}}.fBZP6cJIvXkmJbmOzcl8{margin:24px 0 0}.QHx8SaLcbQvGerhMzc6T{flex-direction:column;gap:4px;margin:20px 0 40px;display:flex}.fj83wFCP7X4nUx08xtP7{margin:8px 0}.fj83wFCP7X4nUx08xtP7:empty{display:none}.k2HZcGDJC4Mvs8FKqBTx{flex-direction:column;gap:24px;display:flex}.FaUKAD8Fgcucpxm8HDEp{margin-bottom:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Rknu6s59issafFobTt9o`,
	"breadcrumbs": `fBZP6cJIvXkmJbmOzcl8`,
	"header": `QHx8SaLcbQvGerhMzc6T`,
	"seatsInfo": `fj83wFCP7X4nUx08xtP7`,
	"content": `k2HZcGDJC4Mvs8FKqBTx`,
	"sendInviteButton": `FaUKAD8Fgcucpxm8HDEp`
};
export default ___CSS_LOADER_EXPORT___;
